import { useAnim, useSEO } from "../hooks.jsx";
import { Link } from "react-router-dom";
import { GUIDES, PAGE_SEO, breadcrumb } from "../data.js";
import { Ic } from "../icons.jsx";
import CtaBand from "../components/CtaBand.jsx";
import Breadcrumb from "../components/Breadcrumb.jsx";

const VOCI = [
  { t: "Sito di prenotazione", d: "È incluso nel canone o va costruito/pagato a parte con un altro strumento?" },
  { t: "Disponibilità in tempo reale", d: "Il calendario si aggiorna subito quando arriva una prenotazione, da qualunque canale?" },
  { t: "Pagamenti online", d: "L'integrazione con carte/pagamenti è nativa o richiede un servizio esterno da collegare a mano?" },
  { t: "Contratti", d: "Il PDF si genera automaticamente dai dati della prenotazione, o va compilato manualmente ogni volta?" },
  { t: "Dominio personalizzato", d: "È incluso, o è un costo annuale a parte non menzionato nel prezzo pubblicizzato?" },
  { t: "Limiti su veicoli e admin", d: "Cosa succede — e cosa costa — quando superi la soglia del piano che stai valutando?" },
  { t: "Assistenza dichiarata", d: "Qual è il tempo di risposta reale (24h, 48h, 72h) e c'è un SLA scritto, non solo promesso a voce?" },
  { t: "Portabilità dei dati", d: "Se in futuro vuoi cambiare fornitore, puoi esportare veicoli, clienti e storico prenotazioni, o resti bloccato?" },
  { t: "Prova gratuita", d: "Puoi provarlo davvero prima di pagare, senza dover inserire una carta di credito?" },
  { t: "Costi non nella prima pagina", d: "Commissioni sui pagamenti, addon storage, superamento veicoli: sono scritti da qualche parte o li scopri solo chiedendo?" },
];

const BC_ITEMS = [{ name: "Checklist confronto gestionali", path: "/checklist-confronto-gestionali-autonoleggio" }];

export default function ChecklistConfrontoGestionali({ go }) {
  useAnim();
  useSEO({
    ...PAGE_SEO["checklist-confronto-gestionali-autonoleggio"],
    schema: breadcrumb(BC_ITEMS),
  });

  return (
    <>
      <Breadcrumb items={BC_ITEMS} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Checklist</div>
          <h1 className="h2" style={{ fontSize: "clamp(1.9rem,4vw,2.9rem)" }}>
            Checklist per <mark>confrontare gestionali</mark>
          </h1>
          <p className="lead" style={{ marginTop: ".65rem" }}>
            10 punti da controllare durante una demo o un preventivo, così
            non scopri dopo aver firmato cosa non era incluso. Vale per
            qualsiasi fornitore tu stia valutando.
          </p>
        </div>
      </section>

      <section className="sec" style={{ background: "var(--bg)" }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <div className="an" style={{ display: "flex", flexDirection: "column", gap: "1rem", marginBottom: "2.5rem" }}>
            {VOCI.map((v, i) => (
              <div
                key={v.t}
                style={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "flex-start",
                  padding: "1rem 1.1rem",
                  borderRadius: 12,
                  border: "1px solid var(--border, #e6e9f0)",
                }}
              >
                <div
                  style={{
                    flexShrink: 0,
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    border: "2px solid var(--muted)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: 2,
                  }}
                >
                  <Ic n="check" s={15} />
                </div>
                <div>
                  <div style={{ fontWeight: 600, marginBottom: ".2rem" }}>
                    {i + 1}. {v.t}
                  </div>
                  <div style={{ fontSize: ".92rem", color: "var(--muted)", lineHeight: 1.65 }}>{v.d}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="an" style={{ padding: "1.5rem", borderRadius: 14, background: "var(--bg2, #f6f8fc)" }}>
            <h2 style={{ fontSize: "1.15rem", marginBottom: ".5rem" }}>
              Come risponde NoleggioinCloud a questi 10 punti
            </h2>
            <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: ".75rem" }}>
              Sito incluso, calendario in tempo reale, pagamenti Stripe
              nativi, contratti PDF automatici, prova gratuita di 14 giorni
              senza carta di credito e prezzi con le voci incluse elencate
              nella pagina piani, non nascoste in una chiamata commerciale.
            </p>
            <Link to="/prezzi" style={{ fontWeight: 600 }}>
              Vedi i piani e cosa include ciascuno →
            </Link>
          </div>

          <div className="an" style={{ marginTop: "2rem" }}>
            <h2 style={{ fontSize: "1.05rem", marginBottom: ".5rem" }}>Approfondisci</h2>
            <ul style={{ paddingLeft: "1.1rem", color: "var(--muted)", fontSize: ".95rem", lineHeight: 2 }}>
              {GUIDES.filter((g) => g.slug !== "checklist-confronto-gestionali-autonoleggio").map((g) => (
                <li key={g.slug}>
                  <Link to={`/${g.slug}`}>{g.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <CtaBand go={go} />
    </>
  );
}
